import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const Channel = Loadable(lazy(() => import('views/Channel')));
const ChannelPricing = Loadable(lazy(() => import('views/ChannelPricing')));
const ChannelStats = Loadable(lazy(() => import('views/ChannelStats')));
const AvailableModels = Loadable(lazy(() => import('views/AvailableModels')));
const Log = Loadable(lazy(() => import('views/Log')));
const Redemption = Loadable(lazy(() => import('views/Redemption')));
const Setting = Loadable(lazy(() => import('views/Setting')));
const Token = Loadable(lazy(() => import('views/Token')));
const Topup = Loadable(lazy(() => import('views/Topup')));
const User = Loadable(lazy(() => import('views/User')));
const UserPricing = Loadable(lazy(() => import('views/UserPricing')));
const Profile = Loadable(lazy(() => import('views/Profile')));
const Chat = Loadable(lazy(() => import('views/Chat')));
const ModelSquare = Loadable(lazy(() => import('views/ModelSquare')));
const VideoGeneration = Loadable(lazy(() => import('views/VideoGeneration')));
const ImageGeneration = Loadable(lazy(() => import('views/ImageGeneration')));
const ApiDoc = Loadable(lazy(() => import('views/ApiDoc')));
const NotFoundView = Loadable(lazy(() => import('views/Error')));

// dashboard routing
const Dashboard = Loadable(lazy(() => import('views/Dashboard')));
const UsageStats = Loadable(lazy(() => import('views/UsageStats')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/panel',
  element: <MainLayout />,
  children: [
    {
      path: '',
      element: <Chat />
    },
    {
      path: 'dashboard',
      element: <Dashboard />
    },
    {
      path: 'usage_stats',
      element: <UsageStats />
    },
    {
      path: 'channel',
      element: <Channel />
    },
    {
      path: 'channel/pricing',
      element: <ChannelPricing />
    },
    {
      path: 'channel/stats',
      element: <ChannelStats />
    },
    {
      path: 'channel/available_models',
      element: <AvailableModels />
    },
    {
      path: 'chat',
      element: <Chat />
    },
    {
      path: 'video',
      element: <VideoGeneration />
    },
    {
      path: 'image',
      element: <ImageGeneration />
    },
    {
      path: 'log',
      element: <Log />
    },
    {
      path: 'redemption',
      element: <Redemption />
    },
    {
      path: 'setting',
      element: <Setting />
    },
    {
      path: 'api_doc',
      element: <ApiDoc />
    },
    {
      path: 'token',
      element: <Token />
    },
    {
      path: 'model_square',
      element: <ModelSquare />
    },
    {
      path: 'topup',
      element: <Topup />
    },
    {
      path: 'user',
      element: <User />
    },
    {
      path: 'user/pricing',
      element: <UserPricing />
    },
    {
      path: 'profile',
      element: <Profile />
    },
    {
      path: '404',
      element: <NotFoundView />
    }
  ]
};

export default MainRoutes;
